import React from 'react';
import { Table, Button, Modal, Form, Input, Switch, Space, Typography, Tag, notification } from 'antd';
import { PlusOutlined, EditOutlined } from '@ant-design/icons';

import { useAuth } from '../../authentication/AuthProvider';
import request from '../../lib/request';
import { useBooks, BooksSelector, BooksCaption } from '../../lib/books';

/** Branches - Transaction Analysis 2 of one set of books (departments and projects are analyses 1 and 3). */
export default function BranchesPage() {
  const auth = useAuth();
  const canEdit = auth.user.role === 'SYSTEM_ADMIN' || auth.user.role === 'COMPANY_MANAGER';
  const { ledgerId } = useBooks();
  const [rows, setRows] = React.useState([]);
  const [editing, setEditing] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [form] = Form.useForm();

  const fetchRows = () => {
    if (!ledgerId) return setRows([]);
    request.get('/branches', { ledger_id: ledgerId }).then((r) => r.json()).then((r) => r.status && setRows(r.data));
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(fetchRows, [ledgerId]);

  const save = () => {
    form.validateFields().then((values) => {
      (editing ? request.put(`/branches/${editing.id}`, values) : request.post('/branches', { ...values, ledger_id: ledgerId }))
        .then((r) => r.json())
        .then((r) => {
          if (r.status) {
            notification.success({ message: 'Branch saved' });
            setOpen(false);
            fetchRows();
          } else notification.error({ message: r.message });
        });
    });
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16, gap: 16 }}>
        <div>
          <Typography.Title level={4} style={{ margin: 0 }}>
            Branches
          </Typography.Title>
          <div><BooksCaption /></div>
          <Typography.Text type="secondary">Transaction analysis by branch or location; tagged on ledger lines next to department and project.</Typography.Text>
        </div>
        <Space wrap>
          <BooksSelector />
          {canEdit && (
            <Button type="primary" icon={<PlusOutlined />} disabled={!ledgerId} onClick={() => { setEditing(null); form.resetFields(); form.setFieldsValue({ is_active: true }); setOpen(true); }}>
              New Branch
            </Button>
          )}
        </Space>
      </div>
      <Table
        rowKey="id"
        size="small"
        pagination={false}
        dataSource={rows}
        columns={[
          { title: 'Code', dataIndex: 'code', width: 120 },
          { title: 'Name', dataIndex: 'name' },
          { title: 'Active', dataIndex: 'is_active', width: 100, render: (v) => <Tag color={v ? 'green' : 'default'}>{v ? 'Active' : 'Inactive'}</Tag> },
          ...(canEdit ? [{ title: '', key: 'a', width: 80, render: (_, b) => <Button size="small" icon={<EditOutlined />} onClick={() => { setEditing(b); form.setFieldsValue(b); setOpen(true); }} /> }] : []),
        ]}
      />
      <Modal title={editing ? `Edit ${editing.code}` : 'New Branch'} open={open} onCancel={() => setOpen(false)} onOk={save}>
        <Form form={form} layout="vertical">
          <Form.Item name="code" label="Code" rules={[{ required: true }]}>
            <Input maxLength={20} placeholder="e.g. NIC, LIM" />
          </Form.Item>
          <Form.Item name="name" label="Name" rules={[{ required: true }]}>
            <Input maxLength={120} />
          </Form.Item>
          <Form.Item name="is_active" label="Active" valuePropName="checked">
            <Switch />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}
